import ThemedQrcode from '@/components/ThemedQrcode'
import { ElPopover, ElSpace } from 'element-plus'
import { useI18n } from 'i18n-utils'
import { useEnvStore } from 'store'
import { DownloadIcon } from 'ui-components'
import './HeaderAppDownload.scss'

export const HeaderAppDownload = defineComponent({
  setup() {
    const { t } = useI18n()
    const envStore = useEnvStore()
    // const baseInfoStore = useBaseInfoStore()

    const qrCodeDownloadUrl = computed(() => {
      return envStore.config?.qrcodeDownload?.oriUrl || ''
    })

    // const { onGoToDownloadTestFlight, onGoToDownloadIos, onGoToDownloadGooglePlay, onGoToDownloadAndroid } = useDownloadConfig()

    return () => (
      <div class="header-app-download-layout">
        <ElPopover effect="light" placement="bottom-end" showArrow={false} offset={22} hideAfter={0} showAfter={0} trigger={'hover'} teleported={false} width={'auto'}>
          {{
            reference: () => (
              <ElSpace>
                <DownloadIcon />
                <span class="download-btn-text">{t('APP下载')}</span>
              </ElSpace>
            ),
            default: () => (
              <div class="app-download-popover-layout">
                {/* <div class="left-wrap">
                  <div class="icon-wrap" onClick={onGoToDownloadIos}>
                    <AppStoreIcon />
                    <span class="text">App Store</span>
                  </div>
                  {envStore.config?.downloadAppInfo?.defultTestFlightUrl || baseInfoStore.webInitInfo?.testFlightUrl ? (
                    <div class="icon-wrap" onClick={onGoToDownloadTestFlight}>
                      <TestFlightIcon />
                      <span class="text">TestFlight</span>
                    </div>
                  ) : null}
                  <div class="icon-wrap" onClick={onGoToDownloadGooglePlay}>
                    <GooglePlayStore />
                    <span class="text">Google Play</span>
                  </div>

                  <div class="icon-wrap" onClick={onGoToDownloadAndroid}>
                    <AndroidApkIcon />
                    <span class="text">Android</span>
                  </div>
                </div> */}
                <div class="right-wrap">
                  <div class={'qr-code-container'}>
                    <ThemedQrcode class="qr-code-canvas" value={qrCodeDownloadUrl.value} size={128} level="H" margin={2} />
                  </div>
                  <div class="download-tip">
                    <span class="main-tip">{t('APP下载')} </span>
                    <span class={'sub-tip'}>{t('iOS&Android 扫码下载')}</span>
                  </div>
                </div>
              </div>
            ),
          }}
        </ElPopover>
      </div>
    )
  },
})
